import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ORGANIZATION_FEATURE_KEY,
  State,
  OrganizationPartialState,
} from './organization.reducer';

// Lookup the 'Organizations' feature state managed by NgRx
export const getOrganizationState = createFeatureSelector<
  OrganizationPartialState,
  State
>(ORGANIZATION_FEATURE_KEY);

export const getOrganizationLoaded = createSelector(
  getOrganizationState,
  (state: State) => state.loaded
);

export const getCurrentOrganization = createSelector(
  getOrganizationState,
  (state: State) => state.organization
);

export const uploadOrganizationImage = createSelector(
  getOrganizationState,
  (state: State) => state.organization
);

export const getOrganizationImage = createSelector(
  getOrganizationState,
  (state: State) => state.organization.images[0].url
);
